// extracted by mini-css-extract-plugin
export default {"stepper":"Stepper_stepper__bcb49","button":"Stepper_button__ac489","input":"Stepper_input__20995"};